import {
    AppWidgetState,
    BaseWidgetRequest,
    CreateWidgetRequest,
    SummaryWidgetRequest,
    VisualizationWidgetRequest,
} from '@ddv/models';

import { getFilters } from './get-filters';
import { getFunds } from './get-funds';
import { getSummaryConfig } from './get-summary-config';
import { getVisualizationConfigs } from './get-visualization-configs';

export function convertToCreateWidgetRequest(coreWidgetConfig: AppWidgetState): CreateWidgetRequest {
    if (coreWidgetConfig.coreWidgetType === 'SUMMARY') {
        return getCreateSummaryWidgetRequest(coreWidgetConfig);
    }

    return getCreateVisualizationWidgetRequest(coreWidgetConfig);
}

function getCreateSummaryWidgetRequest(coreWidgetConfig: AppWidgetState): SummaryWidgetRequest {
    return {
        ...getBaseWidgetRequest(coreWidgetConfig),
        coreWidgetType: 'SUMMARY',
        summaryConfig: getSummaryConfig(coreWidgetConfig.summaryConfig),
    };
}

function getCreateVisualizationWidgetRequest(coreWidgetConfig: AppWidgetState): VisualizationWidgetRequest {
    return {
        ...getBaseWidgetRequest(coreWidgetConfig),
        coreWidgetType: 'VISUALIZATION',
        visualizationConfigs: getVisualizationConfigs(coreWidgetConfig.visualizationConfigs),
    };
}

function getBaseWidgetRequest(coreWidgetConfig: AppWidgetState): BaseWidgetRequest {
    return {
        name: coreWidgetConfig.name,
        description: coreWidgetConfig.description,
        customDisplayName: coreWidgetConfig.customDisplayName ?? null,
        displayNameType: coreWidgetConfig.displayNameType ?? 'AUTO',
        enableWidgetHeader: !!coreWidgetConfig.enableWidgetHeader,
        isSelectable: !!coreWidgetConfig.isSelectable,
        isShared: !!coreWidgetConfig.isShared,
        namedQueryId: coreWidgetConfig.namedQueryId ?? '',
        sharing: coreWidgetConfig.sharing,
        widgetFilters: {
            funds: getFunds(coreWidgetConfig.widgetFilters?.funds ?? []),
            clients: coreWidgetConfig.widgetFilters?.clients ?? [],
            filters: getFilters(coreWidgetConfig.widgetFilters?.filters ?? []),
            startDate: coreWidgetConfig.widgetFilters?.startDate ?? '',
            endDate: coreWidgetConfig.widgetFilters?.endDate ?? '',
            activeDate: coreWidgetConfig.widgetFilters?.activeDate ?? null,
        },
        widgetSettings: {
            isSubscribedToDashboardFilters: !!coreWidgetConfig.isSubscribedToDashboardFilters,
            isActiveDate: !!coreWidgetConfig.isActiveDate,
        },
    };
}
